<template>
  <v-app>
    <router-view></router-view>
    <v-snackbar v-model="snackbar.showing" top :color=snackbar.color :timeout=tm()>{{ snackbar.text }}
      <v-btn v-if="snackbar.color === 'error'" @click="snackbar.showing = false" dark text>Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState(['snackbar'])
  },
  methods: {
    tm() {
      if (this.snackbar.color == 'error') return 0; else return 4000;
    }
  }
};
</script>
